export const menuList = [
  {
    title: '数据看板',
    path: '/dashboard',
  },
  {
    title: '广告位管理',
    path: '/banner/list',
  },
  {
    title: '认证管理',
    path: '/mold/cert/list',
  },
  {
    title: '项目管理',
    children: [
      { title: '项目列表', path: '/mold/project/list' },
      { title: '项目审核', path: '/mold/project/audit' },
    ],
  },
  {
    title: '服务商管理',
    path: '/mold/provider/list',
  },
  {
    title: '评价管理',
    path: '/mold/review/list',
  },
  {
    title: '数据字典',
    children: [
      { title: '模具分类', path: '/mold/moldCategory/list' },
      { title: '行业类型', path: '/mold/industryType/list' },
    ],
  },
  {
    title: '系统管理',
    children: [
      { title: '管理员列表', path: '/admin/list' },
      { title: '系统配置', path: '/system/settings' },
      { title: '操作日志', path: '/system/log' },
    ],
  },
]
